module.exports = __webpack_public_path__ + "img/promotion-bg-3.345da01a.png";